/**
 * connection constants
 */
export const SET_IS_ONLINE = 'SET_IS_ONLINE';
